import { Col, Row, Card } from "react-bootstrap";
import {
  FaAngular,
  FaReact,
  FaBootstrap,
  FaGitAlt,
} from "react-icons/fa";
import {
  SiJavascript,
  SiTypescript,
  SiSass,
  SiTailwindcss,
  SiChartdotjs,
  SiMui, SiRedux, SiJira,SiNodedotjs,
    SiExpress,
  SiMongodb,
  SiPostman,
  SiWordpress,
  SiElementor,
} from "react-icons/si";
import { FaServer } from "react-icons/fa";

function Techstack() {
const skills = [
  // Core Frontend
  { name: "Angular", icon: <FaAngular />, color: "#dd1b16" },
  { name: "React JS", icon: <FaReact />, color: "#61dafb" },
  { name: "Node JS", icon: <SiNodedotjs />, color: "#68A063" },
  { name: "JavaScript", icon: <SiJavascript />, color: "#f7df1e" },
  { name: "TypeScript", icon: <SiTypescript />, color: "#3178c6" },

  // Backend (MERN)
  { name: "Express.js", icon: <SiExpress />, color: "#000000" },
  { name: "MongoDB", icon: <SiMongodb />, color: "#47A248" },
  { name: "REST APIs", icon: <FaServer />, color: "#4caf50" },

  // State Management
  { name: "Redux/NgRx", icon: <SiRedux />, color: "#764abc" },
  // Styling
  { name: "SCSS", icon: <SiSass />, color: "#cc6699" },
  { name: "Bootstrap", icon: <FaBootstrap />, color: "#7952b3" },
  { name: "Tailwind CSS", icon: <SiTailwindcss />, color: "#38bdf8" },
  { name: "Material UI", icon: <SiMui />, color: "#007FFF" },

  // Tools & Workflow
  { name: "Git / GitHub", icon: <FaGitAlt />, color: "#f05032" },
  { name: "Jira", icon: <SiJira />, color: "#0052cc" },
  { name: "Postman", icon: <SiPostman />, color: "#ff6c37" },

  // CMS
  { name: "WordPress", icon: <SiWordpress />, color: "#21759b" },
  { name: "Elementor", icon: <SiElementor />, color: "#92003b" },

  // Libraries
{ name: "NPM", icon: <SiChartdotjs />, color: "#ff6384" },
];


  return (
<Row className="justify-content-center pb-5 mt-3 g-3">
  {skills.map((skill, index) => (
    <Col key={index} xs={6} sm={4} md={3} lg={2} className="d-flex">
      <Card className="skill-card text-center w-100">
        <Card.Body className="d-flex flex-column align-items-center justify-content-center">
          <div
            className="skill-icon"
            style={{ color: skill.color, fontSize: "2rem" }}
          >
            {skill.icon}
          </div>
          <div className="skill-name mt-2 text-white">
            {skill.name}
          </div>
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>


  );
}

export default Techstack;
